var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-snackbar",
    {
      attrs: {
        outlined: "",
        absolute: "",
        top: "",
        dismissible: "",
        color: "error"
      },
      scopedSlots: _vm._u([
        {
          key: "action",
          fn: function({ attrs }) {
            return [
              _c(
                "v-btn",
                _vm._b(
                  {
                    attrs: { color: "red", text: "" },
                    on: { click: _vm.clearErrors }
                  },
                  "v-btn",
                  attrs,
                  false
                ),
                [_c("span", [_vm._v("Close")])]
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _vm.show
        ? _c(
            "div",
            { staticClass: "text-uppercase" },
            [
              _c("v-icon", { staticClass: "error--text mr-2" }, [
                _vm._v("mdi-alert")
              ]),
              _c("span", [_vm._v(_vm._s(_vm.show.first()))])
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }